import React from 'react';
import { t } from 'bv-i18n';

const EmptyBetslipView = () => (
  <div className="betslip__empty">
    <p className="betslip__empty_title">{t('betslip.empty_betslip.title')}</p>
    <p>{t('betslip.empty_betslip.to_select_bet_click_any_price')}</p>
  </div>
);

export default EmptyBetslipView;
